import { pushWishlistEvent } from '../data-layer/wishlist.js';

const useWishlistEvent = ()=>{
    const handlePushWishlistEvent = (messageType, interactionType, siteFeature, sku)=>{
        pushWishlistEvent({
            siteFeature,
            interactionType,
            messageType,
            item: {
                sku
            }
        });
    };
    return {
        handlePushWishlistEvent
    };
};

export { useWishlistEvent };
//# sourceMappingURL=use-wishlist-event.js.map
